import React, { Component } from 'react';
import cx from 'classnames';
import ButtonHoverRender from '../ButtonHover/ButtonHoverRender';
import ButtonHover from '../ButtonHover/ButtonHover';
import LinkHover from '../Link/LinkHover';
import './Dropdown.scss';

class Dropdown extends Component {
  constructor() {
    super();
    this.state = {
      expand: false,
    };
  }

  toggleExpand = () => {
    this.setState(state => ({ expand: !state.expand }));
  };

  renderOptions = show => {
    const {
      dropdownOpts,
      newTab,
      normal,
      hover,
      isMobile,
      tourId,
      tourName,
      aid,
    } = this.props;

    return dropdownOpts.map(({ id, name, url }, i) => {
      return (
        name && (
          <li
            className="option"
            key={id}
          >
            <LinkHover
              tourId={tourId}
              tourName={tourName}
              index={i}
              className="option-link"
              title={name}
              url={url}
              newTab={newTab}
              normal={normal}
              hover={hover}
              show={show && isMobile}
              isMobile={isMobile}
              aid={aid}
            />
          </li>
        )
      );
    });
  };

  render() {
    const { expand } = this.state;
    const {
      title,
      className,
      hover,
      normal,
      isMobile,
      dropdownOpts,
    } = this.props;
    // only render if there is at least one dropdown with a name
    const hasDropdowns = dropdownOpts?.filter(btn => btn.name);
    const ddClasses = cx({ [className]: true, active: expand });

    return (
      hasDropdowns && (
        <div className="dd-wrapper">
          <ButtonHoverRender
            render={({ onEnter, onLeave, hovering }) => (
              <ButtonHover
                onEnter={onEnter}
                onLeave={onLeave}
                hovering={hovering}
                className={ddClasses}
                handleClick={this.toggleExpand}
                hover={hover}
                normal={normal}
                active={expand}
                isMobile={isMobile}
              >
                <div className="dd-title">{title}</div>
                <i aria-hidden="true" className="material-icons">
                  {expand ? 'arrow_drop_up' : 'arrow_drop_down'}
                </i>
              </ButtonHover>
            )}
          />
          {expand && (
            <ul className="dd-options">{this.renderOptions(expand)}</ul>
          )}
        </div>
      )
    );
  }
}

export default Dropdown;
